import { useCurrentUser } from "./useCurrentUser";

export function useOrgExplorerRoleEnabled(): boolean {
  const currentUser = useCurrentUser();
  return currentUser?.org?.explorerEnabled ?? false;
}
